'use client';

import { Button, Input } from '@app/_components/ui';
import { useForm, ValidationError } from '@formspree/react';
import { useCallback } from 'react';
import type { Dictionary } from 'types';

import { cn } from '@/lib/utils';

export default function ProductPageLargeOrderForm({
    formReference,
    formDictionary,
}: {
    formReference?: string;
    formDictionary: Dictionary;
}) {
    const [state, handleSubmit] = useForm(formReference ?? 'mqapbzbv');

    const isInputError = useCallback(
        (inputName: string) =>
            state?.errors.some((error) => error.field === inputName),
        [state.errors],
    );

    if (state.succeeded) {
        return (
            <div className="flex flex-col gap-2 bg-grey-100 p-4">
                <h2 className="text-sm font-medium">
                    {formDictionary.placeOrderFormSuccessHeading ??
                        formDictionary.formSuccessHeading}
                </h2>
                <p className="text-sm">
                    {formDictionary.placeOrderFormSuccessText ??
                        formDictionary.formSuccessText}
                </p>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-2">
            <Input
                className={cn(isInputError('name') && 'border-error')}
                type="text"
                name="name"
                label={formDictionary.placeOrderFormNameLabel}
                required
            />
            <ValidationError prefix="Name" field="name" errors={state.errors} />
            <Input
                className={cn(isInputError('email') && 'border-error')}
                type="email"
                name="email"
                label={formDictionary.placeOrderFormEmailLabel}
                required
            />
            <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
            />
            <Input
                className={cn(isInputError('phoneNumber') && 'border-error')}
                type="tel"
                name="phoneNumber"
                label={formDictionary.placeOrderFormPhoneNumberLabel}
                required
            />
            <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
            />
            <textarea
                className={cn(
                    'w-full border border-grey-200 px-3 py-2 text-base placeholder:text-sm focus:border-black disabled:border-grey-150 disabled:bg-grey-50 disabled:text-grey-300',
                    isInputError('message') && 'border-error',
                )}
                id="message"
                name="message"
                placeholder={formDictionary.placeOrderFormMessageLabel + '*'}
                required
            />
            <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
            />
            <Button
                className="mt-2"
                variant="primary"
                size="lg"
                type="submit"
                disabled={state.submitting}>
                {formDictionary.placeOrderFormSubmitButtonLabel}
            </Button>
        </form>
    );
}
